import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useRoomDetailTableStyles = makeStyles({
  root: {
    overflowX: 'auto',
  },
  badge: {
    ...shorthands.padding('2px', tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    display: 'inline-block',
  },
  badgeConstrained: {
    backgroundColor: tokens.colorPaletteRedBackground2,
    color: tokens.colorPaletteRedForeground1,
  },
  badgeHealthy: {
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorPaletteGreenForeground1,
  },
  badgeUnderutilized: {
    backgroundColor: tokens.colorPaletteMarigoldBackground2,
    color: tokens.colorPaletteMarigoldForeground2,
  },
  typeBadge: {
    ...shorthands.padding('2px', tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    display: 'inline-block',
    backgroundColor: tokens.colorNeutralBackground3,
  },
  utilConstrained: { color: tokens.colorPaletteRedForeground1, fontWeight: tokens.fontWeightSemibold },
  utilHealthy: { color: tokens.colorPaletteGreenForeground1, fontWeight: tokens.fontWeightSemibold },
  utilUnderutilized: { color: tokens.colorPaletteMarigoldForeground2, fontWeight: tokens.fontWeightSemibold },
});
